import { Chip } from '@material-ui/core';
import { Status } from '../../../services/exams/assessmentSession/assessments.types';

export const getStatus = (type: Status): JSX.Element => {
  switch (type) {
    case Status.Open:
      return (
        <Chip
          style={{
            color: '#3560FF',
            justifyContent: 'center',
            borderColor: '#3560FF',
          }}
          label="Otwarte"
          variant="outlined"
          size="small"
        />
      );
    case Status.New:
      return (
        <Chip
          style={{
            color: '#9747FF',
            borderColor: '#9747FF',
            justifyContent: 'center',
          }}
          label="Nowe"
          variant="outlined"
          size="small"
        />
      );
    case Status.Assessed:
      return (
        <Chip
          style={{
            color: '#347F42',
            borderColor: '#347F42',
            justifyContent: 'center',
          }}
          label="Ocenione"
          variant="outlined"
          size="small"
        />
      );
    case Status.Closed:
      return (
        <Chip
          style={{
            color: '#EA2075',
            borderColor: '#EA2075',
            justifyContent: 'center',
          }}
          label="Zamknięte"
          variant="outlined"
          size="small"
        />
      );
    default:
      return <></>;
  }
};
